import ValidationError from '@/error/validationError'

export default class AppValidationError extends ValidationError {
  constructor(constraints: Map<string, Array<string>>) {
    super(constraints)
    this.name = 'AppValidationError'
  }
}
